/* eslint-disable @typescript-eslint/no-explicit-any */
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import moment from 'moment';
 
interface Cheque {
  numero: string;
  dataoperacao: Date;
  datadeposito: Date;
  databaixa: Date;
  nome: string;
  historico: string;
  tipostatus: string;
  valor: number;
}

async function RelatorioChequeEmitidos(dados: Cheque[], periodo: string){
  
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  const TValor = dados.reduce((acc, item) => acc + item.valor, 0);
  const rows = dados.map((row) => {
    return [
      {text: moment(row.dataoperacao).format('DD/MM/YYYY'), alignment: 'center',  fontSize: 8},
      {text: moment(row.datadeposito).format('DD/MM/YYYY'), alignment: 'center',  fontSize: 8},
      {text:  (row.databaixa ? ( moment(row.databaixa).format('DD/MM/YYYY')) : ('')) , alignment: 'center',  fontSize: 8},
      {text: row.numero, alignment: 'left',  fontSize: 7},
      {text: row.nome, alignment: 'left',  fontSize: 7},
      {text: row.historico, alignment: 'left',  fontSize: 7},
      {text: row.tipostatus, alignment: 'left',  fontSize: 7},
      {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(row.valor), alignment: 'right', fontSize: 8},
    ]; 
  });    

  async function getBase64ImageFromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img: HTMLImageElement = new Image();
      img.crossOrigin = 'Anonymous'; 
      img.onload = function () {
        const canvas: HTMLCanvasElement = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('Não foi possível obter o contexto 2D');
          return;
        }
        const image = this as HTMLImageElement;
        canvas.height = image.naturalHeight;
        canvas.width = image.naturalWidth;
        ctx.drawImage(image, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };
      img.onerror = function () {
        reject(`Não foi possível carregar a imagem de ${url}`);
      };
      img.src = url;
    });
  }

  const imageUrl =  process.env.REACT_APP_URL_IMGLOG || ''; 
  const imageData = await getBase64ImageFromUrl(imageUrl);

  if (!imageData.startsWith('data:image')) {
    return new Error('A imagem não foi convertida corretamente para base64.');
  }


  const documentDefinition : any = {
    pageSize: 'A4',
    pageMargins: [20, 10, 20, 10],
    pageOrientation: 'landscape',  
    header: 'simple text',
    footer: {
      columns: [
        'Left part',
        { text: 'Right part', alignment: 'right' }
      ]
    },
    content: ([
      {   
        table: {
          body: [
            [ 
              {
                image: imageData,
                width: 48,
                border: [false, false, false, false]
              },
              {
                border: [false, false, false, false],  
                table: {
                  widths: [720],
                  body: [
                    [ 
                      {text: process.env.REACT_APP_URL_EMPRESA, fontSize: 16,  margin: [0, 5, 0, 0], bold: true, color: process.env.COR_RELATORIOS_TEXTO,  alignment: 'center', fillColor: process.env.COR_RELATORIOS, border: [false, false, false, false]},
                    ],
                    [ 
                      {text: process.env.REACT_APP_URL_ENDERECO, fontSize: 10, border: [false, false, false, true]},
                    ],
                  ]
                }
              },
              
            ],
            [
              {text: 'Relatório de Cheque Emitidos', colSpan: 2, margin: [5, 10, 0, 0], fontSize: 18, bold: true,  alignment: 'center',  border: [false, false, false, false]},
              {}
            ]
            
          ]
        }
      },
      {text: periodo,  fontSize: 8},
      {
        table:{
          widths: [45, 45, 45, 30, 180, 200, 130, 47],
          body: [
            [
              {text: 'Data', alignment: 'center', fillColor: '#dddddd', fontSize: 8},
              {text: 'Deposito', alignment: 'center', fillColor: '#dddddd', fontSize: 8},
              {text: 'Data Baixa', alignment: 'center', fillColor: '#dddddd',  fontSize: 8},
              {text: 'Numero', alignment: 'center', fillColor: '#dddddd', fontSize: 8},
              {text: 'Parceiro', alignment: 'center', fillColor: '#dddddd', fontSize: 8},
              {text: 'Histórico', alignment: 'center', fillColor: '#dddddd', fontSize: 8},
              {text: 'Status', alignment: 'center', fillColor: '#dddddd',  fontSize: 8},
              {text: 'Valor', alignment: 'right', fillColor: '#dddddd', fontSize: 8},
            ],
            ...rows,
            [  
              {text: '', border: [false, false, false, false]},
              {text: '', border: [false, false, false, false]},
              {text: '', border: [false, false, false, false]},
              {text: '', border: [false, false, false, false]},  
              {text: '', border: [false, false, false, false]},
              {text: '', border: [false, false, false, false]},
              {text: 'Totais',  fontSize: 8, alignment: 'right',  border: [false, false, false, false]},
              {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(TValor), alignment: 'right', fontSize: 7},
            ]
          ]
          
        },
      }, 
      
    ]),
      
  };

  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);

  pdfDocGenerator.open();

}
export default RelatorioChequeEmitidos;

